export const WEBVIEW_PLATFORM_NAME = {
  IOS: 'ios',
  ANDROID: 'android'
};

export const CONSTANTS = {
  WEBVIEW_APP_VERSION: 'fajdklfjlefnslekfjsd',
  WEBVIEW_PLATFORM: 'pladdspalcpfedewdr',
  WEBVIEW_PLATFORM_TYPE: 'platform-type', // will be removing this by setting platform in pladdspalcpfedewdr in android,
  IS_WINGG_APP: 'sapa5f876gjaskjhbf',
  IS_WEBVIEW_ACTIVE: 'IS_WEBVIEW_ACTIVE',
  WEBVIEW_APP_NAME: 'APP_NAME'
};
